import { render, staticRenderFns } from "./clientPayments.vue?vue&type=template&id=19b49f08&"
import script from "./clientPayments.vue?vue&type=script&lang=js&"
export * from "./clientPayments.vue?vue&type=script&lang=js&"
import style0 from "./clientPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports